<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-card-title
                style="background-color: #009688; color: white;"
            >
                History for: {{ data && data.MSU_N }}
            </v-card-title>
            <v-card-text style="padding-top: 15px;">
                <v-textarea
                    v-model="placeholderData.HISTORY"
                    :single-line="true"
                    hide-details
                    outlined
                    color="teal darken-1"
                    :readonly="true"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="teal darken-1 white--text" @click="showDialog = false">
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['show', 'data'],
    data: () =>({
        placeholderData: {
            MSU_N: null,
            HISTORY: null
        }
    }),
    computed: {
        showDialog: {
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        initData() {
            if (this.data) {
                this.placeholderData = structuredClone(this.data)
            }
        }
    }
}
</script>
